import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from 'reactstrap';
import { VerificationState } from '../../../features/ingest/ingestSlice';
import IngestActions from '../../../features/ingest/ingestActions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import TpIcapCardHeader from '../../../features/tpIcapCardHeader/TpIcapCardHeader';
import Report from './Report';

export default (state: VerificationState) => {
  const actions = new IngestActions(useDispatch());

  useEffect(() => {
    actions.loadFileTypes();
    actions.loadGroups();
    actions.loadFileFormats();
  }, []);

  return (
    <>
      <Row>
        <Col>
          <Card>
            <TpIcapCardHeader>
              <Row>
                <Col md="auto">
                  <h4 className="mt-0">Verification Report</h4>
                </Col>
              </Row>
            </TpIcapCardHeader>
            <CardBody>
              <Report {...state} />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={state.cancelling}>
        <ModalHeader color="danger">Cancelling upload</ModalHeader>
        <ModalBody>
          <div className="al-center">
            <Spinner className="mr-3" />
            Please wait...
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
